// extracted by mini-css-extract-plugin
module.exports = {"main":"style_main__F7Vh9","header":"style_header__1bZja"};